import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';

import { Grid, Box, Typography } from '@mui/material';
import FieldView from 'core/components/layout/FieldView';


export default function ProductInfoUnderOrder({ productObj }) {
  const { productcompositionList, productDashboard } = useSelector((state) => state.pharmaslice);
  const [productCompList, setProductCompList] = useState([]);

  const [productCtItemList, setProductCtItemList] = useState([]);
  const { ctitemList } = useSelector((state) => state.pharmaslice)

  useEffect(() => {
    setProductCompList(
      productcompositionList.filter(compObj => compObj.productid === productObj.id)
    )

    setProductCtItemList(ctitemList.filter(ctObj => ctObj.ctid === productObj.ctid))
  }, [])

  return (
    <>

      <Grid
        container
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >


        <Grid item lg={12} sx={{ overflowY: "scroll", maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            sx={{}}
          >
            {/* <Grid item lg={2} xs={6}><FieldView label="Product ID" value={productObj.id} /></Grid> */}
            <Grid item lg={2} xs={6}><FieldView label="Brand Name" value={productObj.brandname} /></Grid>
            <Grid item lg={1} xs={6}><FieldView label="Rate" value={productObj.rate !== null && productObj.rate !== undefined ? productObj.rate : 'NOT KNONWN'} /></Grid>
            <Grid item lg={1} xs={6}><FieldView label="MRP" value={productObj.mrptext !== null && productObj.mrptext !== undefined ? productObj.mrptext : 'NOT KNONWN'} /></Grid>
            <Grid item lg={1} xs={6}><FieldView label="Boxes" value={productObj.batchsize !== null && productObj.batchsize !== undefined ? productObj.batchsize : 'NOT KNONWN'} /></Grid>
            
            {/* <Grid item lg={2} xs={6}><FieldView label="Expiry Date" value={productObj.expirydate !== null && productObj.expirydate !== undefined ? productObj.expirydate.split('T')[0] : 'NOT KNONWN'} /></Grid> */}
            <Grid item lg={1} xs={6}><FieldView label="CR/CASH" value={productObj.cr_cash !== null && productObj.cr_cash !== undefined ? productObj.cr_cash : 'NOT KNONWN'} /></Grid>

            {/* <Grid item lg={2} xs={6}><FieldView label="Form Name" value={productObj.formname !== null && productObj.formname !== undefined ? productObj.formname : 'NOT KNONWN'} /></Grid> */}


            {/* <Grid item lg={2} xs={6}><FieldView label="Packaging" value={productObj.packaging !== null && productObj.packaging !== undefined ? productObj.packaging : 'NOT KNONWN'} /></Grid> */}
            <Grid item lg={2} xs={6}><FieldView label="Packaging Material" value={productObj.packagingtypename !== null && productObj.packagingtypename !== undefined ? productObj.packagingtypename : 'NOT KNONWN'} /></Grid>
            {(productObj.formname === "Tablet") || productObj.formname === "Capsul" || productObj.formname === "Sachet" ?
              <>
                <Grid item lg={2} xs={6}><FieldView label={productObj.formname === "Sachet" ? 'Sachets per Box' : 'Strip(s) per Box'} value={productObj.packagingsize1name !== null && productObj.packagingsize1name !== undefined ? productObj.packagingsize1name : 'NOT KNONWN'} /></Grid>
                <Grid item lg={2} xs={6}><FieldView label={productObj.formname === "Sachet" ? 'GRM(s) per Sachet' : 'Item(s) per Strip'} value={productObj.packagingsize2name !== null && productObj.packagingsize2name !== undefined ? productObj.packagingsize2name : 'NOT KNONWN'} /></Grid>
                {/* <Grid item lg={3} xs={6}><FieldView label="Shape Name" value={productObj.shapename !== null && productObj.shapename !== undefined ? productObj.shapename : 'NOT KNONWN'} /></Grid>
                <Grid item lg={2} xs={6}><FieldView label="Set" value={productObj.setname !== null && productObj.setname !== '' && productObj.setname !== undefined ? productObj.setname : 'NOT KNONWN'} /></Grid> */}
              </>
              : <>
                <Grid item lg={2} xs={6}><FieldView label={productObj.formname === "Liquid" || productObj.formname === "Lotion" || productObj.formname === "Gargle" ? 'ML(s) per Packaing' : 'GRM(s) per Packing'} value={productObj.packagingsize2name !== null && productObj.packagingsize2name !== undefined ? productObj.packagingsize2name : 'NOT KNONWN'} /></Grid>
              </>}



            <Grid item lg={5} xs={6}><FieldView label="Remarks" value={productObj.remarks !== '' ? productObj.remarks : 'NO Remarks'} /></Grid>

          </Grid>
        </Grid>

        <Grid item lg={12} sx={{ borderTop: '1px solid #d9d9d9', padding: 1, }}>
          <Grid
            container
            direction="row"
            sx={{
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {/* <Grid lg={2} item sx={{ width: '100%' }}><Typography variant="h5">Composition</Typography> </Grid>

              <Grid lg={10} item sx={{ width: '100%', borderLeft: '1px solid #bae7ff' }}>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {
                    productCtItemList.map(ctItemObj => {
                      return (<Grid lg={3} item><FieldView color="primary.200" label={ctItemObj.title} value={ctItemObj.quantity + ' ' + ctItemObj.unitname} /></Grid>)
                    })
                  }


                </Grid>
              </Grid> */}

          </Grid>
        </Grid>
      </Grid>
    </>
  )
}